import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconCopy(props: SvgIconProps) {
  return (
    <SVGIcon width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M11 7V4H13V7H16V9H13V12H11V9H8V7H11Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 3C4 1.34315 5.34315 0 7 0H17C18.6569 0 20 1.34315 20 3V13C20 14.6569 18.6569 16 17 16H16V17C16 18.6569 14.6569 20 13 20H3C1.34315 20 0 18.6569 0 17V7C0 5.34315 1.34315 4 3 4H4V3ZM7 2H17C17.5523 2 18 2.44772 18 3V13C18 13.5523 17.5523 14 17 14H7C6.44772 14 6 13.5523 6 13V3C6 2.44772 6.44772 2 7 2ZM4 6H3C2.44772 6 2 6.44772 2 7V17C2 17.5523 2.44772 18 3 18H13C13.5523 18 14 17.5523 14 17V16H7C5.34315 16 4 14.6569 4 13V6Z"
        fill="currentColor"
      />
    </SVGIcon>
  );
}
